import { render, staticRenderFns } from "./BoardView.vue?vue&type=template&id=a56e24b8&scoped=true"
import script from "./BoardView.vue?vue&type=script&lang=js"
export * from "./BoardView.vue?vue&type=script&lang=js"
import style0 from "./BoardView.vue?vue&type=style&index=0&id=a56e24b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56e24b8",
  null
  
)

export default component.exports